import { toast } from 'react-toastify';
const Success = (message) => toast.success(message, {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "colored",
    progress: undefined,
});
const Error = (message) =>
    toast.error(message, {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
        progress: undefined,
    })
    ;

const SessionEnd = () => {
    toast.error('مهلت استفاده اتمام یافت', {
        position: "top-center",
        autoClose: 30000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
        progress: undefined,
    });
    window.location.reload();

}



export default {
    Success: Success,
    Error: Error,
    SessionEnd:SessionEnd
}

